import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./mycloud.css";
import { FaUpload } from "react-icons/fa";

const MyCloudPage = () => {
  const [showWidget, setShowWidget] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [folders, setFolders] = useState([]);
  const [privacy, setPrivacy] = useState("private");

  const navigate = useNavigate();

  // ---------------------------
  // LOAD USER FOLDERS FROM BACKEND
  // -------------------------------
  

useEffect(() => {
  
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) return;

  fetch(`http://localhost:5000/api/get-folders?uid=${user.uid}`)
    .then((res) => res.json())
    .then((data) => {
      if (data.ok) setFolders(data.folders);
    });
}, []);

  // -------------------------------
  // CREATE NEW FOLDER HANDLER
  // -------------------------------
const handleCreate = async () => {
  if (!folderName.trim()) return alert("Enter folder name");

  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) return alert("Login required");

  const resp = await fetch("http://localhost:5000/api/folder/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      uid: user.uid,
      folderName,
      parentId: null,
      privacy,
    }),
  });

  const data = await resp.json();
  if (!data.ok) return alert("Error creating folder");

  setFolders([...folders, data.folder]);
  setShowWidget(false);
  setFolderName("");
};


  // ---------------------------------------------------
  // JSX START
  // ---------------------------------------------------
  return (
    <div className="cloud-container">
      {/* STORAGE SUMMARY */}
      <div className="storage-sec">
        <h6>Storage Summary</h6>

        <div className="storage-bar">
          <div className="storage-progress"></div>
        </div>

        <p>2.1 GB used of 15 GB</p>
      </div>

      {/* FOLDER SECTION */}
      <section className="quick-folders">
        <div className="folders-sec">
          <h6 style={{ margin: "10px", color: "#444" }}>Folders</h6>

          {folders.length === 0 ? (
            <div className="no-folder-box">
              <div className="upload-square" onClick={() => setShowWidget(true)}>
                <FaUpload className="upload-icon" />
              </div>

              <img
                className="svgimage"
                src="/upload-animate.svg"
                alt="Animation"
              />

              <p className="no-folder-text">No folders available.</p>
            </div>
          ) : (
            <div className="folder-grid2">
              {folders.map((folder, index) => (
                <div
                  className="folder-card"
                  key={index}
                  onClick={() =>
                    navigate(`/main/folder/${folder.folderId}`, {
                      state: folder,
                    })
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="folder-info">
                    <h1 style={{ fontSize: "50px" }}>📁</h1>
                    <p>{folder.folderName}</p>
                  </div>
                </div>
              ))}

              {/* CREATE NEW FOLDER CARD */}
              <div className="folder-card" onClick={() => setShowWidget(true)}>
                <FaUpload className="upload-icon" />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* POPUP WIDGET */}
      {showWidget && (
        <div className="modal-overlay" onClick={() => setShowWidget(false)}>
          <div className="widget-box" onClick={(e) => e.stopPropagation()}>
            <div className="card">
              <h2>Create Folder</h2>

              <label>Enter Folder Name</label>
              <input
                type="text"
                placeholder="Type folder name..."
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />

              <select
                value={privacy}
                onChange={(e) => setPrivacy(e.target.value)}
              >
                <option value="private">Private</option>
                <option value="public">Public</option>
              </select>

              <button className="btn" onClick={handleCreate}>
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyCloudPage;
